import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { store } from './store';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import ConfirmContextProvider from './store/context/ConfirmContextProvider';
import { ReactFlowContext } from './store/context/ReactFlowContext';
import { InputDataProvider } from './store/context/InputDataContext';
import { LoginProvider } from './store/context/LoginContext';
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LoginProvider>
      <InputDataProvider>
      <SnackbarProvider>
        <ConfirmContextProvider>
          <ReactFlowContext>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ReactFlowContext>
        </ConfirmContextProvider>
      </SnackbarProvider>
      </InputDataProvider>
      </LoginProvider>
    </Provider>
  </React.StrictMode>
);
